exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".contactUs-8d59c0cd>a.contactUsTop-603479ad{margin:20px 0px 0px 0px}.contactUs-8d59c0cd>a.contactUsMiddle-f5a7f0dc{margin:10px 0px 0px 0px}.contactUs-8d59c0cd>a.contactUsBottom-d182168f{padding-bottom:0px}.socialCard-8eb89242{display:flex;flex-direction:row nowrap;justify-content:space-between}.articles-18855f3c>:last-child{margin-bottom:0px}.article-44fb9375{margin-bottom:20px}.article-44fb9375>:last-child{margin-top:5px}.article-44fb9375>a.articleTitle-3b8b6c0d{color:#212121;text-decoration:none}.articleTitle-3b8b6c0d{font-size:20px;font-weight:500;line-height:22px;margin-bottom:10px}.articleGrey-5f3d28c1{color:#616161}.articleUrl-8d45f9cb{font-style:italic}\n", ""]);

// Exports
exports.locals = {
	"contactUs": "contactUs-8d59c0cd",
	"contactUsTop": "contactUsTop-603479ad",
	"contactUsMiddle": "contactUsMiddle-f5a7f0dc",
	"contactUsBottom": "contactUsBottom-d182168f",
	"socialCard": "socialCard-8eb89242",
	"articles": "articles-18855f3c",
	"article": "article-44fb9375",
	"articleTitle": "articleTitle-3b8b6c0d",
	"articleGrey": "articleGrey-5f3d28c1",
	"articleUrl": "articleUrl-8d45f9cb"
};